"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageAppointmentFilterToolbarContainer = void 0;
const styles_1 = require("../../../components/ApptTime/FilterToolbar/styles");
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ManageAppointmentFilterToolbarContainer = (0, styled_1.default)(styles_1.FilterContainer) `
  gap: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  margin-bottom: 0;
  top: ${({ headerHeight }) => `${headerHeight - 1}px`};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  > div {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=styles.js.map